import {Injectable, OnInit} from "@angular/core";


export enum WindowSize {
    SMALL,
    MEDIUM,
    LARGE,
    X_LARGE
}

@Injectable()
export class DisplayAgent {


    public getWindowSizeFromScreenWidth(): WindowSize {

        let width = window.screen.width;
        return this.calculateSize(width);
    }

    public calculateSize(width: number) {
        if (width >= 1200) {
            return WindowSize.X_LARGE;
        } else if (width >= 992) {
            return WindowSize.LARGE;
        } else  if (width >= 768) {
            return WindowSize.MEDIUM;
        } else {
            return WindowSize.SMALL;
        }
    }


}